import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function billingReducer(state = initialState.billing, action) {
  const content = { ...state };

  switch (action.type) {
    case types.GET_PAYMENT_BILLING_SUCCESS:
      content.awaitingDowngrade = action.data.awaiting_downgrade;
      content.billingPeriodEnd = action.data.billing_period_end;
      return content;

    case types.UPDATE_AWAITING_DOWNGRADE_SUCCESS: 
      content.awaitingDowngrade = action.awaiting;
      return content;

    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./library/app/reducers/billingReducer.js